"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = withTimestamp;
function withTimestamp(value, datetime = Date.now()) {
    const lastDot = value.lastIndexOf('.');
    const filename = value.slice(0, lastDot);
    const extension = value.slice(lastDot + 1);
    return `${filename}-${datetime}.${extension}`;
}
//# sourceMappingURL=TimestampHelper.js.map